

import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import { LanguageProvider, useLanguage } from './contexts/LanguageContext';
import { AuthProvider } from './components/AuthContext';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import WhatsAppButton from './components/WhatsAppButton';
import Home from './components/pages/Home';
import SavingAccount from './components/pages/SavingAccount';
import Premiumsavingsacco from './components/pages/Premiumsavingsacco';
import Currentaccount from './components/pages/Currentaccount';
import Plan from './components/pages/Plan';
import Branch from './components/pages/Branch';
import Branches from './components/pages/Branches';
import GalleryPage from './components/pages/GalleryPage';
import CustomerServiceCenter from './components/pages/CustomerServiceCenter';
import Loan from './components/pages/Loan';
import Media from './components/pages/Media';
// import AnnualReport from './components/pages/AnnualReport';
import FAQ from './components/pages/FAQ';
import Contact from './components/pages/Contact';
import AboutUs from './components/pages/AboutUs';
import Login from './components/Login';
import Chairman from './components/pages/Chairman';
import ExecutiveDirector from './components/pages/ExecutiveDirector';
import AnnualReport from './components/pages/AnnualReport';
import ManagingDirector from './components/pages/ManagingDirector';
import Calculator from './components/pages/Calculator';
import FDCalculator from './components/pages/FDCalculator';
import LoanCalculator from './components/pages/LoanCalculator';
import Career from './components/pages/Career';
import PrivacyPolicy from './components/pages/PrivacyPolicy';
import TermsConditions from './components/pages/TermsConditions';
import Disclaimer from './components/pages/Disclaimer';

import AdminDashboard from './components/Admin/AdminDashboard';
import AdminRigister from './components/Admin/AdminRigister';
import AdminGallery from './components/Admin/AdminGallery';
import AdminMedia from './components/Admin/AdminMedia';
import MarqueeDisplay from './components/Admin/MarqueeDisplay';
import AdminMarquee from './components/Admin/AdminMarquee';
import AdminEnquiries from './components/Admin/AdminEnquiries';
import AdminCareer from './components/Admin/AdminCareer';
import AdminJobApplications from './components/Admin/AdminJobApplications';
import AdminPopup from './components/Admin/AdminPopup';
import AdminCustomerService from './components/Admin/AdminCustomerService';
import AdminBranch from './components/Admin/AdminBranch';

import MahilaSavingsAccount from './components/pages/MahilaSavingsAccount';


// Layout wrapper component
const LayoutWrapper = ({ children }) => {
  const location = useLocation();
  const { language } = useLanguage();

  // Routes where navbar and footer should be hidden
  const hideLayoutRoutes = ['/login', '/admin-dashboard', '/admin-register', '/admin-gallery', '/admin-media', '/admin-marquee', '/admin-popup', '/admin-enquiries', '/admin-career', '/admin-job-applications', '/admin-customer-service', '/admin-branch'];
  const shouldHideLayout = hideLayoutRoutes.some(route => location.pathname.startsWith(route));

  // Apply Marathi font class when language is Marathi
  const fontClass = language === 'mr' ? 'marathi-font' : '';

  return (
    <>
      <div className={fontClass}>
        {!shouldHideLayout && <Navbar />}
        {children}
        {!shouldHideLayout && <Footer />}
        {!shouldHideLayout && <WhatsAppButton />}
      </div>
    </>
  );
};

function App() {
  return (
    <div>
      <Router>
        <AuthProvider>
          <LanguageProvider>
            <LayoutWrapper>
              <Routes>
                <Route path='/' element={<Home />} />
                <Route path='/:lang' element={<Home />} />
                <Route path='/savings-account' element={<SavingAccount />} />
                <Route path='/savings-account/:lang' element={<SavingAccount />} />
                <Route path='/premium-savings-account' element={<Premiumsavingsacco />} />
                <Route path='/premium-savings-account/:lang' element={<Premiumsavingsacco />} />
                <Route path='/current-account' element={<Currentaccount />} />
                <Route path='/current-account/:lang' element={<Currentaccount />} />
                <Route path='/plan' element={<Plan />} />
                <Route path='/plan/:lang' element={<Plan />} />


                <Route path='/mahila-savings-account' element={<MahilaSavingsAccount />} />
                <Route path='/mahila-savings-account/:lang' element={<MahilaSavingsAccount />} />


                {/* Recurring Plans */}
                <Route path='/plan-recurring' element={<Plan />} />
                <Route path='/plan-recurring/:lang' element={<Plan />} />
                <Route path='/plan-billionaire' element={<Plan />} />
                <Route path='/plan-billionaire/:lang' element={<Plan />} />
                <Route path='/plan-unnati-lakhpati' element={<Plan />} />
                <Route path='/plan-unnati-lakhpati/:lang' element={<Plan />} />
                <Route path='/plan-ujwal-swapnapurti' element={<Plan />} />
                <Route path='/plan-ujwal-swapnapurti/:lang' element={<Plan />} />
                <Route path='/plan-child-saving' element={<Plan />} />
                <Route path='/plan-child-saving/:lang' element={<Plan />} />
                {/* Fixed Deposit Plans */}
                <Route path='/plan-fixed-deposit' element={<Plan />} />
                <Route path='/plan-fixed-deposit/:lang' element={<Plan />} />
                <Route path='/plan-pension' element={<Plan />} />
                <Route path='/plan-pension/:lang' element={<Plan />} />
                <Route path='/plan-half-price' element={<Plan />} />
                <Route path='/plan-half-price/:lang' element={<Plan />} />
                <Route path='/plan-subhmangal' element={<Plan />} />
                <Route path='/plan-subhmangal/:lang' element={<Plan />} />
                <Route path='/plan-double-money' element={<Plan />} />
                <Route path='/plan-double-money/:lang' element={<Plan />} />
                <Route path='/plan-fourfold' element={<Plan />} />
                <Route path='/plan-fourfold/:lang' element={<Plan />} />
                {/* Small Saving Plans */}
                <Route path='/plan-sujata' element={<Plan />} />
                <Route path='/plan-sujata/:lang' element={<Plan />} />
                {/* Unfixed Deposit Plans */}
                <Route path='/plan-unfixed-deposit' element={<Plan />} />
                <Route path='/plan-unfixed-deposit/:lang' element={<Plan />} />
                <Route path='/branch' element={<Branch />} />
                <Route path='/branch/:lang' element={<Branch />} />
                <Route path='/branches' element={<Branches />} />
                <Route path='/branches/:lang' element={<Branches />} />
                <Route path='/gallery' element={<GalleryPage />} />
                <Route path='/gallery/:lang' element={<GalleryPage />} />
                <Route path='/customer-service' element={<CustomerServiceCenter />} />
                <Route path='/customer-service/:lang' element={<CustomerServiceCenter />} />
                <Route path='/loan' element={<Loan />} />
                <Route path='/loan/:lang' element={<Loan />} />
                <Route path='/gold-loan' element={<Loan />} />
                <Route path='/gold-loan/:lang' element={<Loan />} />
                <Route path='/business-loan' element={<Loan />} />
                <Route path='/business-loan/:lang' element={<Loan />} />
                <Route path='/personal-loan' element={<Loan />} />
                <Route path='/personal-loan/:lang' element={<Loan />} />
                <Route path='/salary-loan' element={<Loan />} />
                <Route path='/salary-loan/:lang' element={<Loan />} />
                <Route path='/vehicle-loan' element={<Loan />} />
                <Route path='/vehicle-loan/:lang' element={<Loan />} />
                <Route path='/mortgage-loan' element={<Loan />} />
                <Route path='/mortgage-loan/:lang' element={<Loan />} />
                <Route path='/deposit-loan' element={<Loan />} />
                <Route path='/deposit-loan/:lang' element={<Loan />} />
                <Route path='/cash-credit-loan' element={<Loan />} />
                <Route path='/cash-credit-loan/:lang' element={<Loan />} />
                <Route path='/home-loan' element={<Loan />} />
                <Route path='/home-loan/:lang' element={<Loan />} />
                <Route path='/women-loan' element={<Loan />} />
                <Route path='/women-loan/:lang' element={<Loan />} />
                <Route path='/media' element={<Media />} />
                <Route path='/media/:lang' element={<Media />} />
                {/* <Route path='/annual-report' element={<AnnualReport />} /> */}
                <Route path='/faq' element={<FAQ />} />
                <Route path='/faq/:lang' element={<FAQ />} />
                <Route path='/contact' element={<Contact />} />
                <Route path='/contact/:lang' element={<Contact />} />
                <Route path='/about' element={<AboutUs />} />
                <Route path='/about/:lang' element={<AboutUs />} />
                <Route path='/login' element={<Login />} />
                <Route path='/chairman' element={<Chairman />} />
                <Route path='/chairman/:lang' element={<Chairman />} />
                <Route path='/executive-director' element={<ExecutiveDirector />} />
                <Route path='/executive-director/:lang' element={<ExecutiveDirector />} />
                <Route path='/annual-report' element={<AnnualReport />} />
                <Route path='/annual-report/:lang' element={<AnnualReport />} />
                <Route path='/managing-director' element={<ManagingDirector />} />
                <Route path='/managing-director/:lang' element={<ManagingDirector />} />
                <Route path='/calculator' element={<Calculator />} />
                <Route path='/calculator/:lang' element={<Calculator />} />
                <Route path='/fd-calculator' element={<FDCalculator />} />
                <Route path='/fd-calculator/:lang' element={<FDCalculator />} />
                <Route path='/loan-calculator' element={<LoanCalculator />} />
                <Route path='/loan-calculator/:lang' element={<LoanCalculator />} />
                <Route path='/career' element={<Career />} />
                <Route path='/career/:lang' element={<Career />} />
                <Route path='/privacy-policy' element={<PrivacyPolicy />} />
                <Route path='/terms-conditions' element={<TermsConditions />} />
                <Route path='/disclaimer' element={<Disclaimer />} />

                <Route path='/admin-dashboard' element={<AdminDashboard />} />
                <Route path='/admin-register' element={<AdminRigister />} />
                <Route path='/admin-gallery' element={<AdminGallery />} />
                <Route path='/admin-media' element={<AdminMedia />} />
                <Route path='/marquee' element={<MarqueeDisplay />} />
                <Route path='/admin-marquee' element={<AdminMarquee />} />
                <Route path='/admin-enquiries' element={<AdminEnquiries />} />
                <Route path='/admin-career' element={<AdminCareer />} />
                <Route path='/admin-job-applications' element={<AdminJobApplications />} />
                <Route path='/admin-popup' element={<AdminPopup />} />
                <Route path='/admin-customer-service' element={<AdminCustomerService />} />
                <Route path='/admin-branch' element={<AdminBranch />} />

              </Routes>
            </LayoutWrapper>
          </LanguageProvider>
        </AuthProvider>
      </Router>
    </div>
  );
}

export default App;
